export function goToHomePage(history) {
    history.push("/home");
}
